import { ENV } from './types';

const value: ENV = {
  // mock
  // HD_API_DOMAIN: '/mock_api',
  // 测试
  // HD_API_DOMAIN: '/dev_api',
  // 生产
  HD_API_DOMAIN: '/production_api',
  // easymock
  // HD_API_DOMAIN: 'http://mock.yfecj.jd.com/mock/5ed46ed3393ecd00365fca1a/acore',
  ACORE_DOMAIN: '//localhost.jd.com:10000',
  TREND_DOMAIN: '//test1.yx.jd.com',
  MC_DOMAIN: '//test.mc.jd.com',
  ACE_DOMAIN: '//beta-ace.jd.com',
  ACE_API_DOMAIN: '//localhost.jd.com:10000/ace_api',
  BABEL_DOMAIN: '//betah5.m.jd.com',
  BABELPRO_DOMAIN: '',
  BABELPRO_PARAMS: '',
  BABELPRO_PC_DOMAIN: '',
  LINGLONG_DOMAIN: '',
  CELUE_DOMAIN: '//beta-smartcms.jd.com',
  QYPT_DOMAIN: '//qypt-test.jd.com',
  WAREOPS_DOMAIN: '//wareops.man.jd.com',
  SECKILLCMS_DOMAIN: '//seckillcmsyx.jd.com',
  DRIPWORKS_DOMAIN: '//dripworks-tk-test-pro.beta-pf.jd.com',
  AUTH_DOMAIN: '//pre.auth.jd.com',
  AUTH_SYSTEM_CODE: 'Qc4RoogaavY6kUGb',
};

export default value;
